import { StatusBanner } from "@/components/StatusBanner";
import { LinkRow } from "@/features/identity/components/LinkRow";
import { AddLinkMenu } from "@/features/identity/components/AddLinkMenu";

export function LinksManager({ editor }) {
  const { rows, errors, load, available, add, update, remove, move, reload } = editor;

  if (load.status === "loading") {
    return (
      <div data-testid="links-loading" className="flex items-center gap-3 py-6">
        <span className="mw-spinner" aria-hidden="true" />
        <span className="mw-eyebrow">Loading your links</span>
      </div>
    );
  }
  if (load.status === "error") {
    return (
      <div className="space-y-4">
        <StatusBanner testId="links-load-error">{load.error}</StatusBanner>
        <button type="button" onClick={reload} data-testid="links-retry-button" className="mw-btn mw-btn-ghost">Try again</button>
      </div>
    );
  }

  return (
    <div data-testid="links-manager" className="space-y-4">
      {rows.length === 0 ? (
        <p data-testid="links-empty" className="rounded-lg border border-dashed border-border px-5 py-8 text-sm text-muted-foreground">
          No links yet. Add the profiles you'd like people to find.
        </p>
      ) : (
        <ul className="space-y-3">
          {rows.map((row, i) => (
            <LinkRow
              key={row.key}
              row={row}
              index={i}
              total={rows.length}
              error={errors[row.key]}
              onUpdate={(patch) => update(row.key, patch)}
              onRemove={() => remove(row.key)}
              onMove={(dir) => move(row.key, dir)}
            />
          ))}
        </ul>
      )}
      <AddLinkMenu available={available} onAdd={add} />
    </div>
  );
}
